import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_283f1782 from 'nuxt_plugin_plugin_283f1782' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_23026540 from 'nuxt_plugin_cookieuniversalnuxt_23026540' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_workbox_58bf3698 from 'nuxt_plugin_workbox_58bf3698' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_1f189072 from 'nuxt_plugin_metaplugin_1f189072' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_15c9458a from 'nuxt_plugin_iconplugin_15c9458a' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_46d65ba3 from 'nuxt_plugin_pluginutils_46d65ba3' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_bea2e7a4 from 'nuxt_plugin_pluginrouting_bea2e7a4' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7cbb7e01 from 'nuxt_plugin_pluginmain_7cbb7e01' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_63b6f598 from 'nuxt_plugin_axios_63b6f598' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_moment_21d34f00 from 'nuxt_plugin_moment_21d34f00' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_fontawesome_2257924c from 'nuxt_plugin_fontawesome_2257924c' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_antd_6a7e33d3 from 'nuxt_plugin_antd_6a7e33d3' // Source: ../plugins/antd (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_animate_05188440 from 'nuxt_plugin_animate_05188440' // Source: ../plugins/animate.css (mode: 'all')
import nuxt_plugin_vueinview_4ce4b8cc from 'nuxt_plugin_vueinview_4ce4b8cc' // Source: ../plugins/vueinview (mode: 'all')
import nuxt_plugin_globalcomponents_91a8526c from 'nuxt_plugin_globalcomponents_91a8526c' // Source: ../plugins/global-components (mode: 'all')
import nuxt_plugin_plugin_82351e58 from 'nuxt_plugin_plugin_82351e58' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_api_785206da from 'nuxt_plugin_api_785206da' // Source: ../plugins/api.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Two Hearts Christmas Horse Show 2022  Presented by X-mobile｜三木ホースランドパークインドアアリーナ","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"2022年12月17日（土）〜18日（日）日本初！人と馬が心を通わせ、競技とエンタメを融合したクリスマホスホースショーを開催！三木ホースランドパークインドアアリーナ（兵庫県三木市）で、選ばれたトップライダー達のトップパフォーマンスをエンターテイメントとして繰り広げます。オリンピック入賞者・福島大輔の馬や馬術競技の魅力を多くの国民に伝えたいという想いから企業とパートナーシップ組み、企画されました。"},{"hid":"og:title","name":"og:title","content":"Two Hearts Christmas Horse Show 2022  Presented by X-mobile｜三木ホースランドパークインドアアリーナ"},{"name":"og:site_name","content":"Two Hearts Christmas Horse Show 2022  Presented by X-mobile｜三木ホースランドパークインドアアリーナ"},{"hid":"og:description","name":"og:description","content":"2022年12月17日（土）〜18日（日）日本初！人と馬が心を通わせ、競技とエンタメを融合したクリスマホスホースショーを開催！三木ホースランドパークインドアアリーナ（兵庫県三木市）で、選ばれたトップライダー達のトップパフォーマンスをエンターテイメントとして繰り広げます。オリンピック入賞者・福島大輔の馬や馬術競技の魅力を多くの国民に伝えたいという想いから企業とパートナーシップ組み、企画されました。"},{"hid":"og:image","name":"og:image","property":"og:image","content":"https:\u002F\u002Fxstable.jp\u002Fimages\u002Fimg-top-banner-pc.jpg"},{"hid":"og:url","name":"og:url","property":"og:url","content":"https:\u002F\u002Fxstable.jp"},{"hid":"og:image:alt","name":"og:image:alt","property":"og:image:alt","content":"Two Hearts Christmas Horse Show 2022  Presented by X-mobile｜三木ホースランドパークインドアアリーナ"},{"name":"apple-mobile-web-app-title","content":"Two Hearts Christmas Horse Show 2022  Presented by X-mobile｜三木ホースランドパークインドアアリーナ"},{"hid":"twitter:card","name":"twitter:card","property":"twitter:card","content":"summary"},{"hid":"twitter:title","name":"twitter:title","property":"twitter:title","content":"Two Hearts Christmas Horse Show 2022  Presented by X-mobile｜三木ホースランドパークインドアアリーナ"},{"hid":"twitter:description","name":"twitter:description","property":"twitter:description","content":"2022年12月17日（土）〜18日（日）日本初！人と馬が心を通わせ、競技とエンタメを融合したクリスマホスホースショーを開催！三木ホースランドパークインドアアリーナ（兵庫県三木市）で、選ばれたトップライダー達のトップパフォーマンスをエンターテイメントとして繰り広げます。オリンピック入賞者・福島大輔の馬や馬術競技の魅力を多くの国民に伝えたいという想いから企業とパートナーシップ組み、企画されました。"},{"hid":"twitter:image","name":"twitter:image","property":"twitter:image","content":"https:\u002F\u002Fxstable.jp\u002Fimages\u002Fimg-top-banner-pc.png"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"hid":"canonical","rel":"canonical","href":"https:\u002F\u002Fxstable.jp"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Noto+Sans+JP:wght@400;500;700;900&display=swap"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_283f1782 === 'function') {
    await nuxt_plugin_plugin_283f1782(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_23026540 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_23026540(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_58bf3698 === 'function') {
    await nuxt_plugin_workbox_58bf3698(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_1f189072 === 'function') {
    await nuxt_plugin_metaplugin_1f189072(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_15c9458a === 'function') {
    await nuxt_plugin_iconplugin_15c9458a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_46d65ba3 === 'function') {
    await nuxt_plugin_pluginutils_46d65ba3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_bea2e7a4 === 'function') {
    await nuxt_plugin_pluginrouting_bea2e7a4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7cbb7e01 === 'function') {
    await nuxt_plugin_pluginmain_7cbb7e01(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_63b6f598 === 'function') {
    await nuxt_plugin_axios_63b6f598(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_21d34f00 === 'function') {
    await nuxt_plugin_moment_21d34f00(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_2257924c === 'function') {
    await nuxt_plugin_fontawesome_2257924c(app.context, inject)
  }

  if (typeof nuxt_plugin_antd_6a7e33d3 === 'function') {
    await nuxt_plugin_antd_6a7e33d3(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (typeof nuxt_plugin_animate_05188440 === 'function') {
    await nuxt_plugin_animate_05188440(app.context, inject)
  }

  if (typeof nuxt_plugin_vueinview_4ce4b8cc === 'function') {
    await nuxt_plugin_vueinview_4ce4b8cc(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_91a8526c === 'function') {
    await nuxt_plugin_globalcomponents_91a8526c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_82351e58 === 'function') {
    await nuxt_plugin_plugin_82351e58(app.context, inject)
  }

  if (typeof nuxt_plugin_api_785206da === 'function') {
    await nuxt_plugin_api_785206da(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
